// src/components/AgeretProductDetail.jsx

import React, { useState } from "react";
import "../assets/css/AgeretProductDetail.css";
import mainImage from "../assets/images/New-Products/Biouv-mineral.jpg";
import thumb1 from "../assets/images/All-Products/Biouvmineral2.png";
import thumb2 from "../assets/images/New-Products/Biouv-mineral.jpg";
import thumb3 from "../assets/images/New-Products/extra/biouvmineralspf50.png";
import howToUseThumb from "../assets/images/skin-breadcrum.jpg";
import howToUseVideo from "../assets/Video/meical video.mp4";
import BredcrumpImage from "../assets/images/skin-breadcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";



const AgeretProductDetails = () => {
  const [selectedImage, setSelectedImage] = useState(mainImage);
  const [activeTab, setActiveTab] = useState("benefits");
  const [showVideo, setShowVideo] = useState(false);

  return (
    <>

      <BreadcrumbSection
        title="Empowering Confidence Through Skin Health."
        // subtitle="Committed to Excellence:"
        breadcrumbItems={[
          { label: "Home", to: "/" }, { label: "Skin Care", to: "/Skin-Care-Products" },

        ]}
        backgroundImage={BredcrumpImage}
      />

      <section className="product-details-section">

        <div className="container product-container">
          {/* Product Image and Details */}
          <div className="product-info">
            <div className="product-image-section">
              <img src={selectedImage} alt="Ageret Product" className="main-image" />
              <div className="thumbnail-row">
                {[thumb1, thumb2, thumb3].map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt={`Thumbnail ${i + 1}`}
                    className={`thumbnail ${selectedImage === img ? "active-thumb" : ""}`}
                    onClick={() => setSelectedImage(img)}
                  />
                ))}
              </div>
            </div>

            <div className="product-description">
              <h2> BioUV MINERAL</h2>
              <p className="sub-heading text-muted">Invisible Shield for your skin </p>
              <h5>Product Overview</h5>
              <p>
                Mineral sunscreen for face that combines high SPF protection with nourishing skincare benefits.
                BioUV Mineral Sunscreen of SPF 50 offers broad-spectrum protection, perfect for daily defense against UV damage,
                especially for those with oily and acne-prone skin.
                The lightweight, non-greasy formula makes it the ideal sunblock cream for oily skin, leaving your face feeling fresh and smooth.
              </p>
            </div>
          </div>

          {/* How To Use Section */}
          {/* <div className="how-to-use-section" data-aos="fade-up">
            <div
              className="how-to-use-content"
              style={{
                backgroundImage: `url(${howToUseThumb})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="text-content">
                <h3>
                  How To Use <span className="highlight"> BioUV MINERAL SPF 50 ?</span>
                </h3>
                <p>
                  Use this medicine in the dose and duration as advised by your doctor. Check the label for directions before use
                </p>
              </div>
              <div className="video-thumbnail-wrapper" onClick={() => setShowVideo(true)}>
                <div className="video-thumbnail">
                  <i className="bi bi-play-fill play-icon"></i>
                </div>
              </div>
            </div>
          </div> */}

          {/* Video Popup Modal */}
          {showVideo && (
            <div className="video-popup">
              <div className="video-container">
                <video controls autoPlay>
                  <source src={howToUseVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>

                {/* Uncomment this block to use YouTube later */}
                {/*
              <iframe
                src="https://www.youtube.com/embed/VIDEO_ID?autoplay=1"
                title="How to Use Ageret"
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
              ></iframe>
              */}

                <button className="close-btn" onClick={() => setShowVideo(false)}>
                  &times;
                </button>
              </div>
            </div>
          )}

          {/* Accordion Section */}
          <div className="accordion-section">
            <div className="accordion-tabs">
              {["benefits", "application", "ingredients", "precautions"].map((tab) => (
                <button
                  key={tab}
                  className={`accordion-tab ${activeTab === tab ? "active" : ""}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab === "benefits"
                    ? "BENEFITS"
                    : tab === "application"
                      ? "APPLICATION GUIDELINES"
                      : tab === "ingredients"
                        ? "INGREDIENTS"
                        : tab === "precautions"
                          ? "PRECAUTIONS"
                          : "BEFORE–AFTER"}
                </button>
              ))}
            </div>

            <div className="accordion-content">
              {activeTab === "benefits" && (
                <div className="tab-content fade-in">
                  <ol>
                    <li>100% Physical, Non-Nano Safety</li>
                    <li>No White Cast Technology</li>
                    <li>Safe for pregnant & lactating women</li>
                    <li>Ideal for sensitive, acne-prone & compromised skin</li>
                    <li>Red algae, Tomato extract & Vitamin E → protect against oxidative stress & DNA damage</li>
                    <li>Non-comedogenic | Hypoallergenic | Vegan | Non-GMO | Paraben & Benzophenone free</li>
                  </ol>

                </div>
              )}
              {activeTab === "application" && (
                <div className="tab-content fade-in">
                  <p>
                    <ol>
                      <li>Take 2 finger-tip units.</li>
                      <li>Apply liberally and evenly to the exposed areas of the skin.</li>
                      <li>Wait for 20 minutes before going out in the sun.</li>
                    </ol>
                  </p>
                </div>
              )}
              {activeTab === "ingredients" && (
                <div className="tab-content fade-in">
                  <p>
                    <ol>
                      <li><strong>Red algae extract:</strong> Porphyra umbilicalis synthesizes UV-absorbing mycosporine amino acids (MAA). MAAs are the strongest UVA-absorbing compounds in nature. Acts as an antioxidant that fights oxidative stress, provides protection against DNA damage, and helps keep skin looking fresh and youthful.</li>

                      <li><strong>Jeju extract:</strong> Prevents free radicals from damaging skin cells. Reduces long-term effects of sun exposure such as premature aging and skin cancer. Helps diminish the appearance of fine lines and wrinkles.</li>

                      <li><strong>Tomato extract:</strong> Contains lycopene, a natural antioxidant. Helps scavenge reactive oxygen species (ROS). Contains carotenoids that protect from excess UV radiation and environmental stressors. Reduces UV-induced erythema and skin damage.</li>

                      <li><strong>Vitamin E:</strong> A free radical scavenger that reduces oxidative stress. Provides protection against harmful UV rays. Helps prevent sunburn and premature aging. Improves skin hydration and reduces inflammation.</li>
                    </ol>
                  </p>
                </div>
              )}
              {activeTab === "precautions" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li>Avoid contact with eyes.</li>
                      <li>If the sunscreen gets into the eyes, rinse thoroughly using cold water.</li>
                    </ul>
                  </p>
                </div>
              )}

            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default AgeretProductDetails;
